const SECONDS_PER_YEAR = 60 * 60 * 24 * 365.2425;

// eslint-disable-next-line import/prefer-default-export
export { SECONDS_PER_YEAR };
